module.exports = __webpack_public_path__ + "img/city_icon.6b070486.svg";